import { render, staticRenderFns } from "./StockUnitTable.vue?vue&type=template&id=5845b4d5&scoped=true"
import script from "./StockUnitTable.vue?vue&type=script&lang=js"
export * from "./StockUnitTable.vue?vue&type=script&lang=js"
import style0 from "./StockUnitTable.vue?vue&type=style&index=0&id=5845b4d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845b4d5",
  null
  
)

export default component.exports